import { useTranslation } from 'react-i18next';

import { LIVE, LIVE_TOPIC, HOME } from 'constants/routingPath';
import useGetOfficialSiteURL from 'hooks/useGetOfficialSiteURL';

const COMMON = 'common';
const NAVBAR = 'navbar';

export default function useGetPathList({ liveTopicInfo = null } = {}) {
  const getOfficialSiteURL = useGetOfficialSiteURL();
  const { t } = useTranslation([NAVBAR, COMMON]);

  const pathList = [
    {
      link: getOfficialSiteURL(HOME),
      label: t('common:common.breadcrumb.home'),
    },
    {
      link: getOfficialSiteURL(LIVE),
      label: t('navbar:navbar.link.live'),
    },
  ];

  if (liveTopicInfo) {
    pathList.push({
      link: getOfficialSiteURL(LIVE_TOPIC, { id: liveTopicInfo.id }),
      label: liveTopicInfo.name,
    });
  }

  return pathList;
}
